import React from "react";

export const GlobalFourthTable = ({
  data,
  columns,
  selectedRows,
  onCheckboxChange,
  onRowClick,
  disableSelection,
}) => {
  const filteredColumns = disableSelection
    ? columns.filter((column) => column.accessor !== "select")
    : columns;

  return (
    <table>
      <thead>
        <tr>
          {!disableSelection && (
            <th>
              <div className="global_col">
                <span>Select</span>
              </div>
            </th>
          )}
          {filteredColumns.map((col, idx) => (
            <th key={idx} className="table_col">
              <div className="global_col">
                <span>{col.label}</span>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, idx) => (
          <tr key={idx} onClick={() => onRowClick && onRowClick(row)}>
            {!disableSelection && (
              <td>
                <input
                  type="checkbox"
                  name={row.submission_id} // Use submission_id as the unique identifier
                  checked={selectedRows.includes(row.submission_id)} // Check if submission_id is in selectedRows
                  onChange={(e) => onCheckboxChange(row.submission_id, e.target.checked)} // Pass submission_id to onCheckboxChange
                />
              </td>
            )}

            {filteredColumns.map((col, colIdx) => (
              <td key={colIdx}>{row[col.accessor]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};